<template>
  <div class="padding-10" v-if="!isLoading">
    <v-card class="padding-5">
      <v-form ref="form" v-model="isValid">
        <Toolbar :way="type" v-model="name"></Toolbar>
        <v-text-field
          outlined
          v-if="isSubject"
          dense
          :rules="rules"
          v-model="subject"
          label="Email Subject"
        ></v-text-field>
        <TemplateInput :type="type" v-model="message"></TemplateInput>
      </v-form>
      <Footer :type="type" @save="submit" @remove="remove"></Footer>
    </v-card>
  </div>
</template>

<script>
import Toolbar from "./create/Toolbar.vue";
import TemplateInput from "./create/TemplateInput.vue";
import Footer from "./create/Footer";
import { templates, auth } from "../../assets/js/firebase";
import default_fields from "../../assets/js/default_fields";
import { getDate } from "../../assets/js/common";
import { getFields } from "../../assets/js/template.helper";
import { FIELD } from "../../assets/js/rules";

export default {
  components: { Toolbar, TemplateInput, Footer },
  data() {
    return {
      isValid: false,
      isLoading: true,
      item: null,
      type: 0,
      message: "",
      name: "",
      subject: "",
      rules: FIELD,
    };
  },
  computed: {
    isSubject() {
      return [1, 2, 5, 13].indexOf(this.type) != -1;
    },
    fields() {
      return getFields(this.message);
    },
    global() {
      return this.$store.getters.globalFields;
    },
    service() {
      if (this.type == 12) return this.$store.getters.serviceFields;
      return this.$store.getters.serviceFields.filter((item) => {
        return item.services && item.services.indexOf(this.id) != -1;
      });
    },
    isDispatch() {
      return this.$route.params.id === "dispatch-job";
    },
    id() {
      return this.$route.params.id;
    },
    fieldList() {
      const vm = this;
      let list = [];
      let inputs = default_fields[vm.type];
      if (!inputs) inputs = [];
      inputs.forEach((item) => {
        list.push(item);
      });
      if (vm.type === 0 || vm.type === 14 || vm.isDispatch) {
        vm.global.forEach((item) => {
          list.push(item.name);
        });
        vm.service.forEach((item) => {
          list.push(item.name);
        });
      }
      console.log("fields", list);
      return list;
    },
  },
  methods: {
    async remove() {
      const vm = this;
      vm.$root.loader = true;
      try {
        await templates.doc(vm.item.id).delete();
        vm.$root.loader = false;
        vm.$root.alert("Template Removed Successfully!", "Note");
        vm.$router.replace("/templates");
      } catch ({ message }) {
        vm.$root.loader = false;
        vm.$root.alert(message);
      }
    },
    async submit() {
      const vm = this;
      let { name, fields, message, type, subject } = vm;
      let date = getDate();
      name = name.trim();
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let check = name.toLowerCase();
      let doc = {
        name,
        message,
        updated_by: auth.currentUser.email,
        check,
        type,
        subject,
        updated_at: date,
        created_at: date,
        fields,
      };
      if (!vm.validateField()) {
        return;
      }
      vm.$root.loader = true;
      try {
        let query = await vm.query(doc).get();
        if (query.docs.length !== 0) {
          if (vm.item === null) {
            vm.$root.loader = false;
            vm.$root.alert(
              "Template Name already exists.<br/>Please enter a unique template Name",
              "Error"
            );
            return;
          }
          if (vm.item !== null && query.docs[0].id !== vm.item.id) {
            vm.$root.loader = false;
            vm.$root.alert(
              "Template Name already exists.<br/>Please enter a unique template Name",
              "Error"
            );
            return;
          }
        }
        if (vm.item === null) {
          await templates.add(doc);
        } else {
          delete doc.created_at;
          await templates.doc(vm.item.id).update(doc);
        }
        vm.$root.loader = false;
        vm.dialog = false;
        if (vm.item !== null) {
          vm.$root.alert("Template Updated Successfully!", "Note");
        } else {
          vm.$root.alert("Template Created Successfully!", "Note");
          vm.$refs.form.reset();
        }
        vm.$router.push("/templates");
      } catch ({ message }) {
        vm.$root.loader = false;
        vm.$root.alert(message);
      }
    },
    validateField() {
      const vm = this;
      let list = vm.fields;
      let { type } = vm;
      let pre = default_fields[vm.type];
      if (!pre) pre = [];
      let check = true;
      if (type === 1) {
        check = list.indexOf("Job_Cancellation_Link") !== -1;
      } else {
        pre.forEach((item) => {
          console.log(list.indexOf(item.id));
          if (list.indexOf(item.id) == -1) check = false;
        });
      }
      console.log(list);
      let fields = pre
        .map((item) => {
          return item.name;
        })
        .toString();
      let msg =
        "Please make sure that these required fields are inserted in the template from the list of predefined fields : <br/>" +
        fields;
      if (type == 1) {
        msg = "Job Cancellation Link field must be required.";
      }

      if (type == 2) check = true;
      if (!check) vm.$root.alert(msg, "Error");
      return check;
    },
    query({ check }) {
      return templates.where("check", "==", check).limit(1);
    },
    toString(str) {
      try {
        str = JSON.parse(str);
      } catch (e) {
        console.log(e);
      }
      return str;
    },
    async init() {
      const vm = this;
      let { name, params } = vm.$route;
      if (name === "template-update") {
        try {
          let { id } = params;
          vm.$root.loader = true;
          let snap = await templates.doc(id).get();
          vm.$root.loader = false;
          if (snap.exists) {
            vm.item = snap.data();
            vm.item.id = snap.id;
            let { message, name, type, subject } = vm.item;
            vm.type = type;
            vm.subject = subject || "";
            vm.name = name;
            vm.message = vm.toString(message);
            vm.isLoading = false;
          } else {
            vm.$root.alert("Template not found");
            vm.$router.replace("/templates");
          }
        } catch (error) {
          vm.$root.loader = false;
          console.log(error);
          vm.$root.alert(error.message);
        }
      } else {
        vm.isLoading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
